const Page4ActionConstants = {
  SET_LOADING: 'SET_LOADING',
  SET_FINAL_STEP_DATA: 'SET_FINAL_STEP_DATA',
  SET_AUTO_SAVE_SECTION_CONFIG: 'SET_AUTO_SAVE_SECTION_CONFIG',
  SET_SEARCHING: 'SET_SEARCHING',
  RESET_DATA: 'RESET_DATA'
};

const setLoading = (loading) => {
  return { type: Page4ActionConstants.SET_LOADING, payload: loading };
};

const setFinalStepData = (data) => {
  return { type: Page4ActionConstants.SET_FINAL_STEP_DATA, payload: data };
};

const setAutoSaveSectionConfig = (config) => {
  return { type: Page4ActionConstants.SET_AUTO_SAVE_SECTION_CONFIG, payload: config };
};

const setSearching = (searching) => {
  return { type: Page4ActionConstants.SET_SEARCHING, payload: searching };
};

export default {
  Page4ActionConstants,
  setLoading,
  setFinalStepData,
  setAutoSaveSectionConfig,
  setSearching
};
